<template>
  <section class="testimonial-section">
    <div class="container">
      <h4 class="testimonial-kicker">Ils parlent de Livratos...</h4>

      <div class="testimonial-wrapper" v-if="currentTestimonial">
        <div class="testimonial">
          <div class="pic">
            <img :src="currentTestimonial.img" :alt="currentTestimonial.name" />
          </div>
          <div class="testimonial-content">
            <p class="description">
              {{ currentTestimonial.message }}
            </p>
            <h3 class="testimonial-title">
              {{ currentTestimonial.name }}
              <small class="post">{{ currentTestimonial.role }}</small>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";

import img1 from "@/assets/partners/img-1.webp";
import img2 from "@/assets/partners/img-2.webp";
import img3 from "@/assets/partners/img-3.webp";

const testimonials = [
  {
    img: img1,
    name: "Christophe M.",
    role: "Gérant d’entreprise de gros œuvre",
    message:
      "Avec Livratos, on arrête de sacrifier un gars pour aller chercher du matériel. Les livraisons arrivent directement sur chantier, et on garde les équipes là où elles créent de la valeur.",
  },
  {
    img: img2,
    name: "Nadia L.",
    role: "Responsable d’agence matériaux",
    message:
      "On a enfin un suivi clair de nos livraisons : ce qui part, pour qui, et quand ça doit arriver. Ça réduit les coups de fil et les malentendus avec les clients pros.",
  },
  {
    img: img3,
    name: "Xavier B.",
    role: "Livreur indépendant BTP",
    message:
      "Les missions sont bien renseignées : type de véhicule, accès chantier, chargement. Je perds moins de temps et j’optimise mes tournées beaucoup plus facilement.",
  },
];

const currentIndex = ref(0);
const currentTestimonial = computed(
  () => testimonials[currentIndex.value] || null
);

let intervalId = null;

onMounted(() => {
  intervalId = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % testimonials.length;
  }, 4000);
});

onBeforeUnmount(() => {
  if (intervalId !== null) {
    clearInterval(intervalId);
  }
});
</script>

<style lang="scss" scoped>
.testimonial-section {
  background-color: $background;
  padding-top: 60px;
  padding-bottom: 80px;
}

.testimonial-kicker {
  color: $color-primary;
  font-style: italic;
  margin-bottom: 100px;
  text-align: center;
}

.testimonial-wrapper {
  max-width: 900px;
  height: 420px;
  margin: 0 auto;
}

.testimonial {
  position: relative;
  padding: 80px 40px 80px 360px;
  border-left: 3px solid $color-primary;
  margin-bottom: 40px;

  &::before,
  &::after {
    content: "";
    width: 360px;
    height: 70px;
    border-right: 3px solid $color-primary;
    position: absolute;
    left: 0;
  }

  &::before {
    border-top: 3px solid $color-primary;
    top: 0;
  }

  &::after {
    border-bottom: 3px solid $color-primary;
    bottom: 0;
  }

  .pic {
    width: 220px;
    height: 220px;
    position: absolute;
    top: 80px;
    left: 80px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 16px;
      box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
    }
  }

  .testimonial-content {
    position: relative;
    margin-left: 15px;

    .description {
      font-size: 1rem;
      color: $color-text-grey;
      line-height: 1.8;
      position: relative;

      &::before {
        content: "\f10d";
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        position: absolute;
        top: -70px;
        left: 0;
        font-size: 20px;
        color: $color-text-grey;
      }
    }

    .testimonial-title {
      font-size: 1.4rem;
      font-weight: 700;
      color: $color-text;
      margin-top: 1.5rem;

      .post {
        display: block;
        font-size: 0.95rem;
        font-weight: 600;
        color: $color-primary;
        margin-top: 5px;
      }
    }
  }
}

@media (max-width: 767px) {
  .testimonial-wrapper {
    height: auto;
  }

  .testimonial {
    padding: 40px 20px;
    margin-bottom: 30px;
    border: 2px solid $color-primary;
    border-radius: 10px;

    &::before,
    &::after {
      display: none;
    }

    .pic {
      position: relative;
      width: 200px;
      height: 200px;
      top: 0;
      left: 0;
      margin: 0 auto 20px auto;
    }

    .testimonial-content {
      text-align: center;

      .description {
        margin-top: 10px;
        padding-top: 0;

        &::before {
          display: none;
        }
      }

      .testimonial-title {
        font-size: 1.2rem;
      }
    }
  }
}
</style>
